/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".amountPill[_ngcontent-%COMP%]{float:right;margin-top:4px}"];
export { styles as styles };
